import './utilities/touch-class.js';
import './utilities/detect-ios.js';
import './utilities/detect-chrome.js';
import './utilities/detect-andriod.js';

import { Component, ViewEncapsulation } from '@angular/core';

import { environment } from '../environments/environment';

declare const ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts